<template>
  <nav class="flex justify-between items-center px-4 py-3 bg-yellow-300 shadow-sm">
    <span>مدیریت تبرک</span>
    <div class="flex">
      <!-- Shopping Cart -->
      <a href="#" @click.prevent="$router.back()" v-if="hasHistory">
        <ChevronLeftIcon class="h-6 w-6"/>
      </a>
    </div>
  </nav>

  <LoadingProgressBar />
  <router-view/>
</template>

<style>
@font-face {
  font-family: 'iransans';
  src: url('assets/font/iran_sans.ttf');
}

* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

*::-webkit-scrollbar {
  display: none;
}

html, body {
  font-family: 'iransans' !important;
  direction: rtl;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;
  @apply bg-gray-100
}


.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

</style>
<script>
import LoadingProgressBar from "@/components/General/LoadingProgressBar";
import {ChevronLeftIcon} from "@heroicons/vue/outline";
export default {
  components: {LoadingProgressBar, ChevronLeftIcon},
  data() {
    return {
      hasHistory: false
    }
  },
  watch: {
    '$route'() {
      this.hasHistory = window.history.length > 1
    }
  }
}
</script>